module.exports = __webpack_public_path__ + "0da8d10eeb8306155964aa7b87c50bb3.svg";